import React from 'react';
import { Drawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';

export const DrawerContainer: React.FunctionComponent<DrawerProps> = ({ children, ...props }) => (
    <Drawer {...props} destroyOnClose width="100%">
        {children}
    </Drawer>
);
